import Http from '@/services/http';

import {
  AlarmConfigurationRequest,
  AlarmConfigurationDetailsRequest,
  AlarmConfigurationDetailsPagedResponse,
  AlarmAssetRequest,
  AlarmAssetListPagedResponse,
  AlarmConfigurationPagedResponse,
  AlarmConfigurationListPagedRequest,

} from 'sigma-mappings';

const urls = {
  updateAlarmClassification: '/alarme/configuracao',
  getAlarmsList: '/alarme/configuracao',
  getAlarmDetails: '/alarme/configuracao/detalhes',
  getAlarmAssets: 'alarme/configuracao/ativos',
  getInstallations: '/instalacao/lookup',
  getAssets: '/ativo/lookup',
};

export default {
  /**
   * Retorna a lista de configurações para classificação de alarmes
   * @param filterOptions.companyId id da empresa
   * @param filterOptions.regionalId id da regional
   * @param filterOptions.installationId id da instalação
   * @param filterOptions.assetId id do ativo
   * @param filterOptions.moduleId id do módulo
   * @param filterOptions.alarmClassification classificação do alarme
   * [undefined, ordinary, urgent, critical]
   * @param filterOptions.display
   * filtra por alarmes que estão ocultos ou não, mas aceita vazio para todos.
   */
  getAlarmsList(filterOptions) {
    const http = new Http();
    const pagedAlarmRequest = new AlarmConfigurationListPagedRequest(filterOptions);
    return http.post(urls.getAlarmsList, pagedAlarmRequest)
      .then(({ data }) => new AlarmConfigurationPagedResponse(data));
  },

  getAlarmDetails(filterOptions) {
    const http = new Http();
    const pagedAlarmRequest = new AlarmConfigurationDetailsRequest(filterOptions);
    return http.post(urls.getAlarmDetails, pagedAlarmRequest)
      .then(({ data }) => new AlarmConfigurationDetailsPagedResponse(data));
  },

  getAlarmAssets(filterOptions) {
    const http = new Http();
    const pagedAlarmRequest = new AlarmAssetRequest(filterOptions);
    return http.post(urls.getAlarmAssets, pagedAlarmRequest)
      .then(({ data }) => new AlarmAssetListPagedResponse(data));
  },
  /**
   * Atualiza a configuração de multiplos alarmes, podem ser alterados classificação e a exibição
   * @param {*} updateParams
   */
  updateAlarmClassification(updateParams) {
    const http = new Http();
    const mappedParams = new AlarmConfigurationRequest(updateParams);
    return http
      .put(
        urls.updateAlarmClassification,
        mappedParams,
      )
      .then(({ data }) => data);
  },
};
